import { render, staticRenderFns } from "./banners-s-3.vue?vue&type=template&id=2fd9d57c"
import script from "./banners-s-3.vue?vue&type=script&lang=js"
export * from "./banners-s-3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports